'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SwapOutButton = _react2['default'].createClass({
    displayName: 'SwapOutButton',


    propTypes: {
        initialButton: _react2['default'].PropTypes.element.isRequired,
        swapInChildren: _react2['default'].PropTypes.element.isRequired
    },

    getInitialState: function getInitialState() {
        return { isSwapped: false };
    },

    doSwap: function doSwap() {
        this.setState({ isSwapped: true });
    },

    render: function render() {
        var children;
        if (this.state.isSwapped) {
            children = this.props.swapInChildren;
        } else {
            children = _react2['default'].cloneElement(this.props.initialButton, {
                'onClick': this.doSwap
            });
        }
        return _jsx('span', {}, void 0, children);
    }

});
module.exports = SwapOutButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/swap-out-button.jsx
 ** module id = 619
 ** module chunks = 0
 **/